var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { toYuan } from '../../utils/unit-conversion';
import request from '../../utils/request';
export default Vue.extend({
    name: 'login',
    components: {},
    props: {
        methods: {
            required: false,
            type: String,
            default: function () {
                return 'get';
            },
        },
        resourceUrl: {
            required: true,
            type: String,
            default: function () {
                return '';
            },
        },
        status: {
            required: false,
            type: String,
            default: function () {
                return '';
            },
        },
    },
    created: function () {
        this.requestData({
            pageNo: 1,
            pageSize: 5,
        });
    },
    computed: {},
    watch: {},
    data: function () {
        return {
            tableData: [
                {
                    id: 1,
                },
                {
                    id: 2,
                },
            ],
            visible: false,
            currentPage: 1,
            currentPageSize: 5,
            totalItems: 30,
            statusForName: {
                APPLIED: '审核中',
                AUDIT_PASS: '放款中',
                LENT: '已放款',
                REPAID: '已还款',
                AUDIT_REFUSED: '审核未通过',
            },
            settleInfo: {},
        };
    },
    methods: {
        apply: function () {
            this.$router.push({
                path: '/console/insurance/apply-loan',
            });
        },
        requestData: function (params) {
            var _this = this;
            if (this.status) {
                params.status = this.status;
            }
            request({
                method: 'post',
                url: this.resourceUrl,
                data: __assign({}, params),
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    var data = res.data;
                    _this.tableData = data;
                    _this.totalItems = data.length;
                }
            });
        },
        pageChange: function (currentPage) {
            this.currentPage = currentPage;
            this.requestData({
                pageNo: currentPage,
                pageSize: this.currentPageSize,
            });
            // this.requestData({
            //   ...this.filterOptions,
            //   currentPage,
            //   currentPageSize: this.currentPageSize
            // })
        },
        pageSizeChange: function (currentPageSize) {
            this.currentPageSize = currentPageSize;
            this.requestData({
                pageNo: this.currentPage,
                pageSize: currentPageSize,
            });
            // this.requestData({
            //   ...this.filterOptions,
            //   showCount: currentPageSize
            // })
        },
        showDetail: function (item) {
            var inforQuery = {
                status: item.status,
                applicationCode: item.applicationCode,
            };
            inforQuery = JSON.stringify(inforQuery);
            this.$router.push({
                path: "/console/insurance/apply-mine/policyDetail",
                query: { inforQuery: inforQuery },
            });
        },
        audit: function (item) {
            this.$router.push({
                path: '/insurance-warm-heart-baby/audit',
                query: {
                    applicationCode: item.applicationCode,
                },
            });
        },
        credit: function (item) {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\">\u662F\u5426\u786E\u8BA4\u8BE5\u8BA2\u5355\u5DF2\u7EBF\u4E0B\u653E\u6B3E\uFF1F</p>",
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                showClose: false,
            })
                .then(function () {
                request({
                    method: 'post',
                    url: '/proxy/api/application/lent',
                    data: {
                        applicationCode: item.applicationCode,
                    },
                }).then(function (res) {
                    if (!res)
                        return;
                    if (!res.errorCode) {
                        _this.requestData({
                            pageNo: _this.currentPage,
                            pageSize: _this.currentPageSize,
                        });
                    }
                    // setTimeout(() => {
                    //   window.location.reload()
                    // }, 300)
                });
            })
                .catch(function () { });
        },
        receipt: function (item) {
            var _this = this;
            this.$confirm('', '', {
                message: "<p class=\"title\">\u662F\u5426\u786E\u8BA4\u8BE5\u8BA2\u5355\u5DF2\u7EBF\u4E0B\u6536\u6B3E\uFF1F</p>",
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                showClose: false,
            })
                .then(function () {
                request({
                    method: 'post',
                    url: '/proxy/api/application/repaid',
                    data: {
                        applicationCode: item.applicationCode,
                    },
                }).then(function (res) {
                    if (!res)
                        return;
                    if (!res.errorCode) {
                        _this.requestData({
                            pageNo: _this.currentPage,
                            pageSize: _this.currentPageSize,
                        });
                    }
                    // setTimeout(() => {
                    //   window.location.reload()
                    // }, 300)
                });
            })
                .catch(function () { });
        },
        settleAccount: function (item) {
            var _this = this;
            request({
                method: 'post',
                url: '/proxy/api/account/info',
                data: {
                    tenantCode: item.tenantCode,
                },
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    _this.settleInfo = res.data;
                }
            });
        },
        // toAgreementDetail (id) {
        //   console.log(id)
        // },
        changeYuan: function (value) {
            return toYuan(value).toFixed(2);
        },
    },
});
